module.exports = __webpack_public_path__ + "img/cake-birthday.3d0bfc31.svg";